import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function PainSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-cream relative" data-id="element-337" data-mp="2uy5ov6khha1p">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-338" data-mp="2uxvw5b820osb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-339" data-mp="2yyzaftagecrf">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-340" data-mp="2bafzt73xlnw6">
            {t('pain.title')}
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-341" data-mp="2ga147x1veoga"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="prose prose-lg prose-brand mx-auto text-brand-charcoal space-y-6" data-id="element-342" data-mp="22at0qryocu6a">
          <p className="text-xl font-medium text-center mb-8" data-id="element-343" data-mp="3nnryqbld6o9i">{t('pain.p1')}</p>

          <p data-id="element-344" data-mp="5f174bodeq3v">{t('pain.p2')}</p>

          <p data-id="element-345" data-mp="gzeaz157cf7">{t('pain.p3')}</p>

          <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 my-10" data-id="element-346" data-mp="hraoc2kde6j">
            <p className="italic text-brand-brown" data-id="element-347" data-mp="38xkrks0t4ro4">{t('pain.quote')}</p>
          </div>

          <p className="font-semibold text-xl text-brand-brown mt-12" data-id="element-348" data-mp="33y7ttc8ee06r">
            {t('pain.truth')}
          </p>

          <p className="text-2xl font-serif text-brand-gold-light text-center my-8" data-id="element-349" data-mp="3ine0fl9kesoo">
            {t('pain.highlight')}
          </p>

          <p data-id="element-350" data-mp="3dtj9bwrmrbfk">{t('pain.p4')}</p>

          <p className="text-xl font-medium text-center mt-8" data-id="element-351" data-mp="2q5s0j35atgj1">{t('pain.p5')}</p>
        </motion.div>
      </div>
    </section>;
}